/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetPayableQueryResponse, GetPayablePathParams, GetPayable400, GetPayable401, GetPayable403, GetPayable404, GetPayable409, GetPayable500 } from "../../types/financialHubController/GetPayable.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getPayable } from "../../client/financialHubController/getPayable.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getPayableQueryKey = (organizationId: GetPayablePathParams["organizationId"] | undefined, billId: GetPayablePathParams["billId"] | undefined) => [{ url: '/api/organizations/:organizationId/financial/payables/:billId', params: {organizationId:organizationId,billId:billId} }] as const

export type GetPayableQueryKey = ReturnType<typeof getPayableQueryKey>

export function getPayableQueryOptions(organizationId: GetPayablePathParams["organizationId"] | undefined, billId: GetPayablePathParams["billId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getPayableQueryKey(organizationId, billId)
        return queryOptions<GetPayableQueryResponse, ResponseErrorConfig<GetPayable400 | GetPayable401 | GetPayable403 | GetPayable404 | GetPayable409 | GetPayable500>, GetPayableQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && billId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getPayable(organizationId!, billId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a supplier bill with its installments + payments
 * {@link /api/organizations/:organizationId/financial/payables/:billId}
 */
export function useGetPayable<TData = GetPayableQueryResponse, TQueryData = GetPayableQueryResponse, TQueryKey extends QueryKey = GetPayableQueryKey>(organizationId: GetPayablePathParams["organizationId"] | undefined, billId: GetPayablePathParams["billId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetPayableQueryResponse, ResponseErrorConfig<GetPayable400 | GetPayable401 | GetPayable403 | GetPayable404 | GetPayable409 | GetPayable500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getPayableQueryKey(organizationId, billId)
         

         const query = useQuery({
          ...getPayableQueryOptions(organizationId, billId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetPayable400 | GetPayable401 | GetPayable403 | GetPayable404 | GetPayable409 | GetPayable500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}